import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import queryString from 'query-string';

import { createDevice } from 'store/deviceReducer';
import DeviceForm from './DeviceForm';

class DeviceNewContainer extends Component {
  constructor(props) {
    super(props);
    const { type } = queryString.parse(this.props.location.search);
    this.state = { type };
  }

  render() {
    const { handleSubmit } = this.props;

    return (
      <DeviceForm
        onSubmit={handleSubmit}
        initialValues={this.state}
      />
    )
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators({
    handleSubmit: values =>
      createDevice([values, () => ownProps.history.push('/account/devices')]),
  }, dispatch);
}

export default connect(null, mapDispatchToProps)(DeviceNewContainer);



// WEBPACK FOOTER //
// ./src/features/device/DeviceNewContainer.js